export {
  whyZapierLink,
  exploreLink,
  resourcesLink,
  teamsLink,
  pricingLink,
  dashboardLink,
  zapsLink,
  myAppsLink,
  historyLink,
  helpLink,
  usageLink,
  moveZapsLink,
  settingsLink,
  logOutLink,
  UniversalSidebarLinks,
  UniversalTopbarLinks,
  AccountsMenuLinks,
} from './links';
export type { UniversalNavLinkType } from './links';

// Account action paths
export const signupPath = '/sign-up/';
export const loginPath = '/app/login';

// Utility constants
export const skipLinkHref = '#mainContent';
export const UNIVERSAL_NAV_ZINDEX = 950;
export const UNIVERSAL_NAV_SUBMENU_ZINDEX = UNIVERSAL_NAV_ZINDEX + 1;
export const UNIVERSAL_TOPBAR_HEIGHT = 70;
export const UNIVERSAL_TOPBAR_CONDENSED_HEIGHT = 60;
export const UNIVERSAL_SIDEBAR_WIDTH = 300;
export const UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH = 70;

// Events related to the App Search Bar
export const searchClosed = 'Zapbook: App Header search closed';
export const searchOpened = 'Zapbook: App Header search opened';
export const searchHasResults = 'Zapbook: Results in search';
export const searchHasNoResults = 'Zapbook: No results in search';
export const searchResultClick = 'Zapbook: App header search result selected';
